import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { Select } from '../../../components/ModalInputs'
import * as Yup from 'yup'
import { getSpecMedGroupsGroups, getSpecMedGroupsStudents, } from '../../../actions/medCenter/specMedGroups'

import Table from '../../../components/Table'
import Button from '../../../components/Button'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, handleChangeStudents, selectedWeekVariant }) {

  const dispatch = useDispatch()
  const { list: sh_do } = useSelector(state => state.do_schedule_variants)
  const { list: sh_vd } = useSelector(state => state.vd_schedule_variants)
  const { list: sh } = useSelector(state => state.schedule_variants)
  const arrWeeksSelect = data == 'sh_do' ? sh_do : data == 'sh_vd' ? sh_vd : sh

  const [selected, setSelected] = useState(null)

  const renderLi = (data) => {
    const { sh_var_name, sh_var_id } = data
    return (
      <tr>
        <td
          onClick={() => handleChangeStudents(data)}
          style={{ backgroundColor: selectedWeekVariant?.find(el => (el.sh_var_id == sh_var_id)) ? '#3689FF' : '' }}
        >
          {sh_var_name}
        </td>
      </tr>
    )
  }


  const handleChange = (e) => {
    setSelected(
      { [e.target.name]: e.target.value }
    )
  }

  const handleSubmit = () => {
  }
  return (
    <Modal
      open={!!data}
      onClose={closeModal}
      closeOnOverlayClick={true}
      closeOnEsc={true}
      showCloseIcon={true}
      height={height}
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            <Table className={styles.table} >
              <thead>
                {/* <tr>
                  <th>Ученица</th>
                </tr> */}
              </thead>
              <tbody>
                {arrWeeksSelect?.map(renderLi)}
              </tbody>
            </Table>
          </div>
        </div>
      </>
    </Modal>

  )
}
